import { Directive, input } from '@angular/core';
import { Subject } from 'rxjs';

export interface NaturalLanguageEditorKeyphraseUpdate<T> {
  phraseId: string;
  value: T;
  feedback?: string;
}

@Directive({
  selector: '[ziroNaturalLanguageEditorKeyphrase]',
  standalone: false,
})
export class NaturalLanguageEditorKeyphraseAbstractDirective<T> {
  readonly phraseId = input.required<string>();

  private _updateSource = new Subject<NaturalLanguageEditorKeyphraseUpdate<T>>();
  update$ = this._updateSource.asObservable();

  entity: T;
  hasValidationError = false;

  onUpdate(update: T): void {
    this.entity = update;
    const feedback = this._generateFeedback(update);
    this.hasValidationError = !!feedback;
    this._updateSource.next({ phraseId: this.phraseId(), value: update, feedback: feedback });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected _generateFeedback(update: T): string {
    return null;
  }
}
